import Navbar from "./navbar";
import {routes} from "../../data/routes";

const Layout = ({ children }) => {
    return (
        <main className="dark:bg-zinc-950 dark:text-gray-100 bg-green-50 min-h-screen pt-8">
            <Navbar routes={routes} />
            <div data-overlay-container={true}>
                <main className="p-4 pb-12 max-w-6xl m-auto overflow-hidden 2xl:overflow-visible">{children}</main>
            </div>
        </main>
    )
}

export default Layout;
